import { render, staticRenderFns } from "./EquipmentView.vue?vue&type=template&id=2a4331dc"
import script from "./EquipmentView.vue?vue&type=script&lang=js"
export * from "./EquipmentView.vue?vue&type=script&lang=js"
import style0 from "./EquipmentView.vue?vue&type=style&index=0&id=2a4331dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports